import { Button } from "@material-ui/core";
import { Theme } from "@material-ui/core";
import { observer } from "mobx-react-lite";
import { inject } from "mobx-react";
import React, { useCallback } from "react";
import { RouteComponentProps } from "react-router";
import { CommonsStore } from "../../../model/CommonsStore";
import { RouterStore } from "../../../router/RouterStore";
import { TitleRow } from "../TitleRow";
import {
  DefaultTitleContainer,
  DefaultViewContainer,
  OneViewProps
} from "../OneView";
import { I18n } from "../../../index";
import { makeStyles } from "@material-ui/styles";
import { Upload } from "../../Inputs/Upload/Upload";

const useStyles = makeStyles((theme: Theme) => {
  return {
    title: {
      marginTop: theme.spacing(3),
      marginBottom: theme.spacing(2)
    },
    titleButtons: {
      marginLeft: theme.spacing(1) * 2
    },
    titleText: {
      verticalAlign: "middle"
    },
    form: {
      display: "grid",
      gridColumn: 1,
      gridRowGap: "20px",
      width: "800px"
    },
    submitButton: {
      marginTop: theme.spacing(1) * 2,
      width: "200px"
    }
  };
});

export interface UploadViewProps<T, ID>
  extends OneViewProps<any, any>,
    Partial<RouteComponentProps> {
  accept: string[];
  onSuccess?: (response: any) => void;
  router?: RouterStore;
  commons?: CommonsStore;
  i18n?: I18n;
  fileName: string;
  multiple?: boolean;
}

export const UploadView = inject(
  "router",
  "commons",
  "i18n"
)(
  observer((props: UploadViewProps<any, any>) => {
    const { title, i18n } = props;
    const classes = useStyles();
    const finalTitle = title || i18n!.t("lego:views.upload.title", "Upload");
    const ViewContainer = props.viewContainer || DefaultViewContainer;
    const TitleContainer = props.titleContainer || DefaultTitleContainer;
    const files = props.dataSource.one || [];

    const submit = useCallback(
      async (event: React.FormEvent) => {
        event.preventDefault();
        props.dataSource.upload().then((response: any) => {
          if (props.onSuccess) {
            props.onSuccess(response);
          } else {
            props.router!.goToParent();
          }
        });
      },
      [props]
    );

    const onChange = useCallback(
      (files: File | File[] | null) => props.dataSource.change(files),
      [props]
    );

    return (
      <ViewContainer>
        <TitleContainer>
          <TitleRow title={finalTitle} classes={classes} />
        </TitleContainer>
        <form onSubmit={submit} className={classes.form}>
          <Upload
            accept={props.accept}
            input={{
              value: files,
              onChange: onChange
            }}
            multiple={props.multiple}
          />
          <Button
            type="submit"
            variant="contained"
            color="primary"
            disabled={
              !props.dataSource.one ||
              Object.keys(props.dataSource.one).length === 0
            }
            className={classes.submitButton}
          >
            {i18n!.t("commons:save", "Save")}
          </Button>
        </form>
      </ViewContainer>
    );
  })
);
